






















import { Component, Prop } from 'vue-property-decorator'

import MatchMixin from '@/mixins/match'

@Component
export default class MatchListItem extends MatchMixin {
  @Prop() readonly shouldClickCopyMatchApiLink!: boolean

  click(): void {
    if (!this.match) {
      return
    }

    if (this.shouldClickCopyMatchApiLink) {
      const apiLink = this.apiLink

      if (!apiLink) {
        window.flash('Unable to copy API-link.', 'error')
        return
      }

      const matchDetails = `'${this.match.hName} - ${this.match.vName}'`

      // window.open(this.apiLink)
      this.$copyText(apiLink).then(() => {
        window.flash(`Copied API-link for match! ${matchDetails}`)
      })
      return
    }

    this.$router.push(`match/${this.match.id}`)
  }
}
